var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4411(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Player-Added-+-Player's-List-(After-Dragging)-(Desktop)",
    transform: "translate(-294.000000, -300.000000)",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34-Copy-7",
    transform: "translate(317.500000, 323.500000) rotate(-180.000000) translate(-317.500000, -323.500000) translate(294.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 43,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17,
    cy: 43,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30,
    cy: 43,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43,
    cy: 43,
    r: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4411);
export default __webpack_public_path__ + "static/media/4-4-1-1.432afe3225fe04e5eb2081c0f3d0b254.svg";
export { ForwardRef as ReactComponent };